import { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from "axios";
import posthog from "posthog-js";

type APIInternalRequestConfig = InternalAxiosRequestConfig & { metadata: { startTime: number } };

export const setupPostHogApiInterceptor = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      const newConfig = { ...config, metadata: { startTime: performance.now() } } as APIInternalRequestConfig;
      return newConfig;
    },
    (error) => Promise.reject(error)
  );

  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
      const duration = performance.now() - (response.config as any).metadata?.startTime;

      posthog.capture("api_call", {
        endpoint: response.config.url,
        method: response.config.method?.toUpperCase(),
        status_code: response.status,
        duration_ms: Math.round(duration),
        success: true,
        request_body: (response.config as any).data,
        request_headers: response.config.headers,
      });

      return response;
    },
    (error) => {
      const duration = performance.now() - (error.config as any)?.metadata?.startTime;

      posthog.capture("api_call", {
        endpoint: error.config?.url,
        method: error.config?.method?.toUpperCase(),
        status_code: error.response?.status || 0,
        duration_ms: Math.round(duration),
        success: false,
        error_message: error.message,
        request_body: (error.config as any)?.data,
        request_headers: error.config?.headers,
        response_body: error.response?.data,
      });

      return Promise.reject(error);
    }
  );
};
